import { Component, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';
import { LanguageService } from '../../_services';
 
@Component({
    selector: 'app-dropdown',
    styleUrls: ['./dropdown.component.scss'],
    templateUrl: './dropdown.component.html',
    standalone: false
})

export class DropdownComponent {

  Show = false
  checkedElements = []
  _selected = '';
  selectedElements;
  
  @Input() elements;
  @Input() multiple;
  @Input() set selected(model){
    if(model){
      this.selectedElements = model
      this.setSelectElements(model)
      this.setCheckedElements(model)
    }
  };
  @Output() selectElement: EventEmitter<any> = new EventEmitter<any>();

  constructor(public languageService: LanguageService,
    private elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.Show = false;
    }
  }
  setSelectElements(model){
    this._selected = ''
    for (let i = 0; i < model.length; i++) {
      const element = this.elements.find((element) => element.id == model[i])
      if(element) this._selected = this._selected+''+element.name[this.languageService.currentLang] +', '
    }
  }

  setCheckedElements(model){
    for (let i = 0; i < this.elements.length; i++) {
      let find = model.find((mission)=> this.elements[i].id == mission)
      if(find) this.checkedElements[i] = true
      else this.checkedElements[i] = false
    }
  }

  toggleCheck(event, i){
    if(event){
      this.selectedElements.push(this.elements[i].id)
    }else{
      const index = this.selectedElements.findIndex((element)=> element== this.elements[i].id)
      if (index > -1) {
        this.selectedElements.splice(index, 1); 
      }
    }
    this.setSelectElements(this.selectedElements)
    this.selectElement.emit(this.selectedElements)
  }

  toggle() {
    this.Show = !this.Show;
  }

}